import { useTranslation } from "react-i18next";

import { LabelAdornment } from "@/modules/theme/components/Label/LabelAdornment";

type PointsLabelProps = {
  points: number;
  className?: string;
};

const translationNamespace = "common/PointsLabel";

export const PointsLabel = ({ points, className }: PointsLabelProps) => {
  const { t } = useTranslation(translationNamespace);

  return (
    <LabelAdornment
      text={t("+{{points}} PT", { points: points })}
      className={className}
    />
  );
};
